'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    path: '*',
    status: 404,
    component: require('containers/NotFound/NotFound').NotFound
  };
};